// react-helmet only processes real HTML elements passed as direct children of
// <Helmet>, so this is a render helper that returns a <script> element rather
// than a wrapper component. Use it inside a Helmet tree:
//
//   <Helmet>{renderJsonLd(schema)}</Helmet>
export const renderJsonLd = data => {
	if (!data) {
		return null;
	}

	return (
		<script type="application/ld+json">{JSON.stringify(data).replace(/</g, "\\u003c")}</script>
	);
};
